module.exports = __webpack_public_path__ + "static/media/testimonial-1.628ced9b.png";